<script setup>
import {mdiCheckBold, mdiCloseThick} from "@mdi/js";
import SelectionButtonsInput from "@/components/forms/SelectionButtonsInput.vue";
import SelectionButton from "@/components/forms/SelectionButton.vue";
import {YesNo, YesNoLabels} from "@/choices";
import {ref} from "vue";

const hasTic = ref(null);
const emit = defineEmits(['submit']);

function submit() {
    emit('submit', {hasTic: hasTic.value});
}
</script>

<template>
    <main>
        <h1>{{ pgettext('title', 'Does the person have a TIC card?') }}</h1>

        <SelectionButtonsInput v-model="hasTic" size="x-large" :height="72" @select="submit()">
            <SelectionButton :value="true" color="green-darken-1" :prepend-icon="mdiCheckBold">
                <strong>{{ YesNoLabels[YesNo.YES] }}</strong>
            </SelectionButton>
            <SelectionButton :value="false" color="red-darken-1" :prepend-icon="mdiCloseThick">
                <strong>{{ YesNoLabels[YesNo.NO] }}</strong>
            </SelectionButton>
        </SelectionButtonsInput>
        <p class="text-center text-subtitle-2">
            {{ gettext('To continue, please select one of the options.') }}
        </p>
    </main>
</template>
